import Container from "@/classes/component-classes/Container";

export default class ContainerExtended extends Container {
    constructor() {

        super();

        this.readOnly = false;
        this.showAddButton = true;
        this.isEditing = false;
        this.isDeleting = false;
    }
}
